module.exports = __webpack_public_path__ + "img/Verified - false.c937335b.svg";